import {Persistor, persistStore} from "redux-persist";

class PersistorManager {
    private persistor?: Persistor;

    setPersistor(persistor: Persistor) {
        this.persistor = persistor;
    }

    initializePersistor(store: any) {
        if (!this.persistor) {
            this.persistor = persistStore(store);
        }
        return this.persistor;
    }

    async purge() {
        if (!this.persistor) {
            console.error('Persistor is not set.');
            return;
        }
        await this.persistor.purge();
    }

    async flush() {
        if (!this.persistor) {
            console.error('Persistor is not set.');
            return;
        }
        await this.persistor.flush();
    }

    subscribe(callback: () => void): () => void {
        if (!this.persistor) {
            console.error('Persistor is not set.');
            return () => {
            };
        }
        return this.persistor.subscribe(callback);
    }
}

export const persistorManager = new PersistorManager();
